function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.46761 11.3342C3.21826 11.076 2.80677 11.0688 2.54851 11.3181C2.29026 11.5675 2.28304 11.9789 2.53239 12.2372L3.46761 11.3342ZM10.4483 19.5L9.98066 19.9515C10.1114 20.0868 10.2943 20.1589 10.4822 20.1491C10.6701 20.1393 10.8445 20.0485 10.9604 19.9003L10.4483 19.5ZM21.5121 6.40028C21.7332 6.11744 21.6831 5.70894 21.4003 5.48787C21.1174 5.2668 20.7089 5.31688 20.4879 5.59972L21.5121 6.40028ZM2.53239 12.2372L9.98066 19.9515L10.9159 19.0485L3.46761 11.3342L2.53239 12.2372ZM10.9604 19.9003L21.5121 6.40028L20.4879 5.59972L9.93615 19.0997L10.9604 19.9003Z",
  fill: "#5575FA"
});

var SvgChosenOption = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChosenOption, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/chosenOption.45f1bb22.svg";
export { ForwardRef as ReactComponent };